import ProjetoComentariosService from '@/services/projetos/projeto-comentarios.service';

export default {
    namespaced: true,
    state: () => ({
        commentsByField: {} // { fieldId: [ array of comments ] }
    }),
    mutations: {
        SET_COMMENTS(state, comments) {
            state.commentsByField = comments;
        },
        ADD_FIELD_COMMENT(state, { fieldId, comment }) {
            if (!state.commentsByField[fieldId]) {
                // Necessário usar Vue.set ou reatividade pura pra garantir que o Vue 2 perceba
                import('vue').then(VueModule => {
                    const Vue = VueModule.default;
                    Vue.set(state.commentsByField, fieldId, []);
                    state.commentsByField[fieldId].push(comment);
                });
            } else {
                state.commentsByField[fieldId].push(comment);
            }
        },
        RESOLVE_FIELD_COMMENTS(state, fieldId) {
            if (state.commentsByField[fieldId]) {
                state.commentsByField[fieldId].forEach(c => {
                    if (c.status === 'aberto') {
                        c.status = 'resolvido';
                    }
                });
            }
        }
    },
    actions: {
        async fetchProjectComments({ commit, rootState }, { empresaId, projetoId }) {
            try {
                // Fallback para caso não passem empresaId
                const eId = empresaId || rootState.clientId || 1;
                const response = await ProjetoComentariosService.getComentarios(eId, projetoId);
                commit('SET_COMMENTS', response.data);
            } catch (error) {
                console.error('Erro ao buscar comentarios do projeto', error);
            }
        }
    },
    getters: {
        getFieldComments: (state) => (fieldId) => {
            return state.commentsByField[fieldId] || [];
        }
    }
};
